<div style="position: relative">
    <div class="start-button" (click)="toggleRecording()">
        <img src="./../../../../../../assets/microphone.png" [ngStyle]="{
        'width.px': uploadedOnce ? '120' : '240',
        'height.px': uploadedOnce ? '120' : '240'
      }" />
        <div style="position: absolute; top: 110px; left: 100px" *ngIf="isRecording && !blobUrl">
            {{ recordedTime }}
        </div>
        <div [ngClass]="uploadedOnce ? 'pulse-ring2' : 'pulse-ring'" *ngIf="isRecording"></div>
    </div>
</div>
